import {BACKEND_API, serialize} from '../middleware/backend'

export const INVOICES_REQUEST = 'INVOICES_REQUEST';
export const INVOICES_SUCCESS = 'INVOICES_SUCCESS';
export const INVOICES_FAILURE = 'INVOICES_FAILURE';
export const INVOICES_COUNT_REQUEST = 'INVOICES_COUNT_REQUEST';
export const INVOICES_COUNT_SUCCESS = 'INVOICES_COUNT_SUCCESS';
export const INVOICES_COUNT_FAILURE = 'INVOICES_COUNT_FAILURE';
export const INVOICE_REQUEST = 'INVOICE_REQUEST';
export const INVOICE_SUCCESS = 'INVOICE_SUCCESS';
export const INVOICE_FAILURE = 'INVOICE_FAILURE';
export const INVOICES_FIND_REQUEST = 'INVOICES_FIND_REQUEST';
export const INVOICES_FIND_SUCCESS = 'INVOICES_FIND_SUCCESS';
export const INVOICES_FIND_FAILURE = 'INVOICES_FIND_FAILURE';
export const INVOICE_SAVE_REQUEST = 'INVOICE_SAVE_REQUEST';
export const INVOICE_SAVE_SUCCESS = 'INVOICE_SAVE_SUCCESS';
export const INVOICE_SAVE_FAILURE = 'INVOICE_SAVE_FAILURE';
export const INVOICE_DELETE_REQUEST = 'INVOICE_DELETE_REQUEST';
export const INVOICE_DELETE_SUCCESS = 'INVOICE_DELETE_SUCCESS';
export const INVOICE_DELETE_FAILURE = 'INVOICE_DELETE_FAILURE';

export const INVOICE_UPDATE_STATUS_REQUEST = 'INVOICE_UPDATE_STATUS_REQUEST';
export const INVOICE_UPDATE_STATUS_SUCCESS = 'INVOICE_UPDATE_STATUS_SUCCESS';
export const INVOICE_UPDATE_STATUS_FAILURE = 'INVOICE_UPDATE_STATUS_FAILURE';

export const INVOICE_CREATE_FROM_TRN_REQUEST = 'INVOICE_CREATE_FROM_TRN_REQUEST';
export const INVOICE_CREATE_FROM_TRN_SUCCESS = 'INVOICE_CREATE_FROM_TRN_SUCCESS';
export const INVOICE_CREATE_FROM_TRN_FAILURE = 'INVOICE_CREATE_FROM_TRN_FAILURE';

export const loadInvoices = (filter) => (dispatch, getState) => {
	return dispatch({
		[BACKEND_API]: {
			types: [INVOICES_REQUEST, INVOICES_SUCCESS, INVOICES_FAILURE],
			endpoint: "invoice/list",
			filter: filter
		}
	})
};

export const countInvoices = (filter) => (dispatch, getState) => {
	return dispatch({
		[BACKEND_API]: {
			types: [INVOICES_COUNT_REQUEST, INVOICES_COUNT_SUCCESS, INVOICES_COUNT_FAILURE],
			endpoint: "invoice/count",
			filter: filter
		}
	})
};

export const loadInvoice = (id) => (dispatch, getState) => {
	return dispatch({
		id: id,
		[BACKEND_API]: {
			types: [INVOICE_REQUEST, INVOICE_SUCCESS, INVOICE_FAILURE],
			endpoint: `invoice/${id}`,
		}
	})
};

export const findInvoices = (filter) => (dispatch, getState) => {
	return dispatch({
		[BACKEND_API]: {
			types: [INVOICES_FIND_REQUEST, INVOICES_FIND_SUCCESS, INVOICES_FIND_FAILURE],
			endpoint: "invoice/find",
			filter: filter
		}
	})
};

export const saveInvoice = (invoice) => (dispatch, getState) => {

	const formData = new FormData();
	const values = Object.assign({}, invoice);
	if (values.file) {
		if (values.file[0]) {
			formData.append('file', values.file[0]);
		}
		values.file = undefined
	}
	formData.append('invoice', serialize(values));


	return dispatch({
		invoice: invoice,
		[BACKEND_API]: {
			types: [INVOICE_SAVE_REQUEST, INVOICE_SAVE_SUCCESS, INVOICE_SAVE_FAILURE],
			endpoint: invoice && invoice.invoiceId ? `invoice/${invoice.invoiceId}` : 'invoice',
			body: formData
		}
	})
};

export const deleteInvoice = (id) => (dispatch, getState) => {
	return dispatch({
		id: id,
		[BACKEND_API]: {
			types: [INVOICE_DELETE_REQUEST, INVOICE_DELETE_SUCCESS, INVOICE_DELETE_FAILURE],
			endpoint: `invoice/${id}`,
			method: 'DELETE'
		}
	})
};

export const createInvoiceFromTrn = (trnId) => (dispatch, getState) => {
	return dispatch({
		[BACKEND_API]: {
			types: [INVOICE_CREATE_FROM_TRN_REQUEST, INVOICE_CREATE_FROM_TRN_SUCCESS, INVOICE_CREATE_FROM_TRN_FAILURE],
			endpoint: `invoice/create/transaction/${trnId}`,
		}
	})
};

export const updateInvoiceStatus = (status, invoiceIds) => (dispatch, getState) => {

	return dispatch({
		[BACKEND_API]: {
			types: [INVOICE_UPDATE_STATUS_REQUEST, INVOICE_UPDATE_STATUS_SUCCESS, INVOICE_UPDATE_STATUS_FAILURE],
			endpoint: `invoice/update-status/${status}`,
			body: invoiceIds
		}
	})
};
